import { Component, State, h } from '@stencil/core';
import state, { store } from '@ugc-store';
import { getArray } from '@ugc-utils/utils';
import { getQuestionAnswers } from '@ugc-api/question';
import { getThumbStatus } from '@ugc-api/helpful-status';
import { filterQuestionInfo, toAnswerInfoList } from '@ugc-components/ugc-pdp-question-and-answer/utils';

@Component({
  tag: 'ugc-qna-view-more-answers-modal',
  shadow: false,
})
export class UgcQnaViewMoreAnswersModal {
  @State() page = 1;
  @State() isDataLoading = false;

  loading = false;

  componentWillLoad() {
    store.onChange('isShowViewMoreAnswersModal', data => {
      if (data) {
        this.page = 1;
      }
    });
  }

  handleCancel() {
    state.isShowViewMoreAnswersModal = false;
    state.viewMoreAnswersData = {
      questionId: '',
      nextPageToken: '',
      answersIdList: [],
      answersDetail: {},
    };
  }

  onScrollList() {
    try {
      const el = document.querySelector('.modal-content');
      const {
        viewMoreAnswersData: { nextPageToken },
      } = state;
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 10) {
        if (nextPageToken && !this.isDataLoading) {
          this.handleLoadAnswersData();
        }
      }
    } catch (e) {}
  }

  async handleLoadAnswersData() {
    const {
      productInfo: { productId = '' },
      viewMoreAnswersData: { questionId = '', answersIdList = [], answersDetail },
      isLogin,
    } = state;

    try {
      this.isDataLoading = true;
      const { items: answers = [], nextPageToken } =
        ((await getQuestionAnswers(productId, questionId, ++this.page)) as any) || {};
      this.isDataLoading = false;

      if (getArray(answers).length === 0) return;
      const { aids, answersBreakUpById } = toAnswerInfoList(answers);
      // get vote status
      try {
        if (isLogin) {
          const data = await getThumbStatus(aids);
          if (data && data.length) {
            data.forEach(({ id, vote }) => {
              if (answersBreakUpById[id]) {
                answersBreakUpById[id].hasThumbsUp = vote;
              }
            });
          }
        }
      } catch (e) {}

      state.viewMoreAnswersData = {
        ...state.viewMoreAnswersData,
        nextPageToken,
        answersIdList: [...answersIdList, ...aids],
        answersDetail: { ...answersDetail, ...answersBreakUpById },
      };
    } catch (e) {
      this.isDataLoading = false;
    }
  }

  render() {
    const {
      isShowViewMoreAnswersModal,
      viewMoreAnswersData: { questionId, answersIdList, answersDetail },
      qnaStaticLanguage: { IDS_UGC_ANSWERS_TO_THE_QUESTION = '' },
    } = state;
    const questionInfo = filterQuestionInfo(questionId);
    const { id, content, questionShareUrl } = questionInfo;
    return (
      <ugc-drawer
        isShow={isShowViewMoreAnswersModal}
        modalTitle={IDS_UGC_ANSWERS_TO_THE_QUESTION}
        isShowButton={false}
        isGray={true}
        handleCancel={this.handleCancel.bind(this)}
        handleScroll={this.onScrollList.bind(this)}
      >
        {isShowViewMoreAnswersModal && (
          <div class="p-24" style={{ minHeight: '70vh' }}>
            {/* question title */}
            <ugc-question-title
              questionInfo={{
                id,
                content,
                questionShareUrl,
              }}
              isModal={true}
            />

            {/* answer item */}
            {answersIdList.map((answerId, index) => {
              if (answerId) {
                return <ugc-answer-item key={answerId} answer={answersDetail[answerId]} isModal={true} index={index} />;
              }
            })}
          </div>
        )}
      </ugc-drawer>
    );
  }
}
